import { config } from "common/config";
import { GraphQLClient } from "graphql-request";

let client: GraphQLClient | null = null;

export const graphQLClient = () => {
    if (!client) {
        const { contentfulEnvironment, contentfulApiKey, contentfulSpaceId } = config;
        client = new GraphQLClient(
            `https://graphql.contentful.com/content/v1/spaces/${contentfulSpaceId}/environments/${contentfulEnvironment}`,
            {
                headers: {
                    Authorization: `Bearer ${contentfulApiKey}`,
                },
            },
        );
    }

    return client;
};
